// --------------------------------------------------------------------------
// Create schema for specific section of site
// --------------------------------------------------------------------------

export function get_product_site_schema(global, location) {
    let dataset = {},
        el_selector = {},
        el = {},
        el_long = {},
        desc = '',
        name = '',
        price = 'N/A';
    if (location === 'odn') {
        el_selector = global.document
            .getElementById('product-data')
            .querySelector('.product');
        el = global.document.querySelector('.donateForm-productDescription p');
        el_long = global.document.querySelector(
            '.donateForm-productDescription'
        );
    } else if (location === 'ogc') {
        el_selector = global.document.getElementById('product-data');
        el = global.document.querySelector('.giftCatalogue-description p');
        el_long = global.document.querySelector('.giftCatalogue-description');
    }
    if (el_selector) {
        dataset = el_selector.dataset;
        if (location === 'odn') {
            name = dataset.name;
            price = '10.00';
        } else {
            name = dataset.product_title;
            price = dataset.product_price;
        }
    }

    if (el) {
        desc = el.innerText;
    } else if (el_long) {
        desc = el_long.innerText;
    }

    if (dataset) {
        let data_object = {
            name: name,
            url: dataset.product_url,
            image: dataset.product_img_url,
            description: desc,
            price: price,
        };
        const data = product_item(data_object);
        build_site_schema(global, data);
    }
}

function product_item(data_object) {
    let link = 'https:';
    let data_product = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: data_object.name,
        url: data_object.url,
        image: link + data_object.image,
        description: data_object.description,
        offers: {
            '@type': 'Offer',
            url: data_object.url,
            priceCurrency: 'CAD',
            price: data_object.price,
        },
    };
    return data_product;
}

function build_site_schema(global, data) {
    if (data) {
        let el = global.document.querySelector('.site-schema');
        el.setAttribute('type', 'application/ld+json');
        el.innerText = JSON.stringify(data);
    }
}
